<template>
    <div v-if="state.inlineLogInShow" class="overlay"></div>
    <div v-if="state.inlineLogInShow" class="card fast-log-in">
        <div class="card-body">
        <h2>Enter password:</h2>
        <input type="password" class="form-control" v-model="state.password" placeholder="Password" />
        <button class="btn btn-primary" @click="submitInlineLogIn">OK</button>
        </div>
    </div>
</template>

<script setup>
import { reactive } from "vue";

const state = reactive({
  inlineLogInShow: false,
  password: '321321000'
});

document.addEventListener('inlineLogInInit', () => {
  state.inlineLogInShow = true
})

// close on timeout event
document.addEventListener('inlineLogInTimeout', () => {
  state.inlineLogInShow = false
})

function submitInlineLogIn() {
  const submitEvent = new CustomEvent('inlineLogInSubmit', { detail: {
    password: state.password
  } });
  window.dispatchEvent(submitEvent);
  state.inlineLogInShow = false
  console.log('inlineLogInSubmit');
}
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
}

.fast-log-in {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;


  user-select: none;
  border-radius: 3px;
  max-width: 300px;
  width: 100%;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.3);

  .card-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>